// 事件总线第三方库：
import mitt from 'mitt'

const bus = mitt()
export default bus
